import FormattedMessage from 'I18n/components/FormattedMessage';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StartTaskQueueUpgrade = ({
  total
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('tasks-start-queue-new');
  return /*#__PURE__*/_jsxs(UIButton, {
    use: 'secondary',
    onClick: openUpgradeModal,
    "data-test-id": "start-task-queue-button",
    "data-selenium-test": "start-task-queue-button",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "queues.startNumTasks",
      options: {
        count: total
      }
    }), /*#__PURE__*/_jsx(UILockBadge, {})]
  });
};
export default StartTaskQueueUpgrade;